import { render, staticRenderFns } from "./ProjectsKanban.vue?vue&type=template&id=13ce4752&scoped=true&"
import script from "./ProjectsKanban.vue?vue&type=script&lang=js&"
export * from "./ProjectsKanban.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsKanban.vue?vue&type=style&index=0&id=13ce4752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ce4752",
  null
  
)

export default component.exports